import { Link } from "react-router-dom";

const items = [
  {
    kicker: "Every week",
    title: "Octopus Anonymous",
    body: "A room where humans arrive as they are. No performance, no camera required, no advice.",
    to: "/octopus-anonymous",
    linkText: "Enter the room",
  },
  {
    kicker: "Running now",
    title: "The Think Tank on human leadership",
    body: "A group of nonlinear thinkers working on what leadership becomes when it is measured in humans, not output.",
    href: "https://octopus-thinktank.institute/",
    linkText: "See the Think Tank",
  },
  {
    kicker: "Local experiment",
    title: "Kids Think Tank",
    body: "Children thinking about the questions adults have given up on, with their own hosts and their own language.",
    to: "/kids-council",
    linkText: "Meet the kids",
  },
];

const AliveNowSection = () => {
  return (
    <section id="alive-now" className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-14">
          <p className="text-sm uppercase tracking-[0.2em] text-coral-text mb-4">What is alive right now</p>
          <h2 className="text-3xl md:text-5xl font-heading font-bold">
            Three things happening{" "}
            <span className="text-gradient-coral">this month.</span>
          </h2>
        </div>

        <div className="divide-y divide-border/60 border-y border-border/60">
          {items.map((item) => (
            <div key={item.title} className="py-8 grid md:grid-cols-12 gap-4 md:gap-8 items-baseline">
              <p className="md:col-span-3 text-xs uppercase tracking-[0.2em] text-muted-foreground">{item.kicker}</p>
              <div className="md:col-span-9">
                <h3 className="text-xl md:text-2xl font-heading font-bold mb-2">{item.title}</h3>
                <p className="text-muted-foreground leading-relaxed mb-3">{item.body}</p>
                {item.to ? (
                  <Link
                    to={item.to}
                    className="inline-flex items-center gap-2 min-h-[44px] text-sm font-medium text-coral-text hover:text-coral transition-colors"
                  >
                    {item.linkText} →
                  </Link>
                ) : (
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 min-h-[44px] text-sm font-medium text-coral-text hover:text-coral transition-colors"
                  >
                    {item.linkText} ↗
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AliveNowSection;